import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { ECCOLogo } from "@ui/components/media-and-icons/ecco-logo/ECCOLogo";
import { NextLink } from "@components/ui/next-link/NextLink";

export const Logo = () => {
    const { get: getMicrocopy } = useMicrocopy();
    return (
        <NextLink
            href="/"
            aria-label={getMicrocopy(CommonCMS.shared, CommonCMS.ariaLabels.homeButtonAria)}
            data-testid="homelink"
            display="flex"
            minW="eccoLogo"
            h={"sizes.icon.md"}
            _hover={{ color: "gray.500" }}
        >
            <ECCOLogo />
        </NextLink>
    );
};
